import pick from 'lodash/pick'
import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

// 案件のもつBPが一つでも指定期間にかぶっていれば true
const hasBpInRange = (insertionOrder, period) => {
  if (period.startDate == null && period.endDate == null) return true

  return insertionOrder.billingPeriods.some(
    bp =>
      dayjs(bp.startTime).isSameOrBefore(period.endDate) &&
      dayjs(bp.endTime).isSameOrAfter(period.startDate),
  )
}

/**
 * 案件データとレポートデータをマージする。
 */
const mergeReportData = ({ reportData, insertionOrders, period }) => {
  if (reportData == null) return null

  const columns = reportData.columns
    .map(c => c.name)
    .filter(c => c !== 'insertionOrder' && c !== 'insertionOrderId')

  return insertionOrders
    .filter(io => hasBpInRange(io, period))
    .map(io => {
      const datum = reportData.data.find(r => r.insertionOrderId === io.id)
      const ioReport = pick(datum, columns)

      return {
        id: io.id,
        name: io.name,
        billingPeriods: io.billingPeriods, // 案件が持つ全てのBP
        ...ioReport,
      }
    })
}

export default mergeReportData
